var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('ul',{staticClass:"yq_list"},_vm._l((_vm.yardList),function(item){return _c('li',{key:item.hospCode,on:{"click":function($event){return _vm.push(item.hospCode)}}},[_vm._v(_vm._s(item.hospName))])}),0),_vm._v(" "),_c('judgment')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302d8bd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HospitalInformation/NavigationSelectionYq.vue
// module id = null
// module chunks = 